(function () {
    'use strict';

    angular
        .module('app.systemLog')
        .factory('systemLogService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) 
            {
                var service = {};

                function handleRequest(url, method, params)
                {
                    var deferred = $q.defer();         
                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params)
                    }

                    $http(req).success(function (response) {
                        deferred.resolve(response);
                    })
                    .error(function () {
                        deferred.reject(null);
                    });

                    return deferred.promise;
                }

                function searchSystemLog(params) 
                {
                    var url_searchSystemLog = $rootScope.apiUrl + 'systemlog/searchSystemLog';
                    return handleRequest(url_searchSystemLog, 'POST', params);
                }

                function searchAccountLog(params) 
                {
                    var url_searchAccountLog = $rootScope.apiUrl + 'systemlog/searchAccountLog';
                    return handleRequest(url_searchAccountLog, 'POST', params);
                }

                function searchUserLog(params) 
                {
                    var url_searchUserLog = $rootScope.apiUrl + 'systemlog/searchUserLog';
                    return handleRequest(url_searchUserLog, 'POST', params);
                }

                service.searchSystemLog = searchSystemLog;
                service.searchAccountLog = searchAccountLog;
                service.searchUserLog = searchUserLog;

                return service;
            }
        ])
})();
